import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import OrderAttachments from './OrderAttachments';
import Material from './Material';
import WorkOrders from './WorkOrders';
import Tasks from './Operations';
import { memo, useEffect } from 'react';
import PlanningConsole from './PlanningConsole';
import {useDispatch, useSelector} from 'react-redux';
import {setSearchCaseOp, setSearchCaseOrder} from "../../redux/search.slice";

const hText = [
  { text: 'Planning Board' },
  { text: 'Work Orders' },
  { text: 'Operations' },
  { text: 'Resource Planning' },
  { text: 'Material' },
  { text: 'Attachments' },
];
var current_tab = 0;
var theTab: TabComponent = new TabComponent({});
function TheTabComponent() {
  const dispatch = useDispatch();
  const theOpSearchFromRedux = useSelector(
    (state: any) => state.search.searchCaseOperation
  );
  const theOrSearchFromRedux = useSelector(
    (state: any) => state.search.searchCaseOrder
  );
  const theGanttSearchFromRedux = useSelector(
    (state: any) => state.search.searchCaseGantt
  );
  const workOrders = () => <WorkOrders needDidMount={false} />;
  const operations = () => <Tasks needDidMount={true} />;
  const materials = () => <Material />;
  const orderAttachments = () => <OrderAttachments />;
  const pConsole = () => <PlanningConsole />;
  const begin = (args: any) => {
    if (args.isSwiped) {
      args.cancel = true;
    }
  };
  useEffect(() => {
    return () => {
      theTab && theTab.destroy();
    };
  }, []);
  useEffect(() => {
    if (theOpSearchFromRedux !== '') {
      theTab.selectedItem = 1;
    }
  }, [theOpSearchFromRedux]);

  useEffect(() => {
    if (theOrSearchFromRedux !== '') {
      theTab.selectedItem = 0;
    }
  }, [theOrSearchFromRedux]);
  useEffect(() => {
    if (theGanttSearchFromRedux !== '') {
      theTab.selectedItem = 2;
    }
  }, [theGanttSearchFromRedux]);
  return (
    <div>
      <TabComponent
        ref={(theRef: TabComponent) => (theTab = theRef)}
        selecting={begin}
        // selectedItem={current_tab}
        selected={(args: any) => {
          current_tab = args.selectedIndex;
          dispatch(setSearchCaseOp(''));
          dispatch(setSearchCaseOrder(''));

        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective header={hText[1]} content={workOrders} />
          <TabItemDirective header={hText[2]} content={operations} />
          <TabItemDirective header={hText[3]} content={pConsole} disabled/>
          <TabItemDirective header={hText[4]} content={materials} disabled/>
          <TabItemDirective header={hText[5]} content={orderAttachments} disabled/>
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
}

export default memo(TheTabComponent);
